import { combineReducers } from 'redux';
import {
  SET_DOWNLOADING_DISCOUNT_BLACKLIST,
  SET_FETCH_DISCOUNT_SETTINGS,
  SET_UPDATE_DISCOUNT_BOTTOM_PRICE,
  SET_UPDATE_DISCOUNT_SETTINGS,
  SET_UPLOADING_DISCOUNT_BLACKLIST,
} from 'state/actionTypes';
import createReducer from 'utils/createReducer';

const blacklistInitialState = {
  uploading: false,
  downloading: false,
};

const blacklist = createReducer(blacklistInitialState, {
  [SET_UPLOADING_DISCOUNT_BLACKLIST]: (state, { payload }) => ({
    ...state,
    uploading: payload.uploading,
  }),
  [SET_DOWNLOADING_DISCOUNT_BLACKLIST]: (state, { payload }) => ({
    ...state,
    downloading: payload.downloading,
  }),
});

const discountSettingsInitialState = {
  discountSettingsIsLoading: false,
  bottomPriceIsLoading: false,
  discountSettings: [],
};

const discountSettings = createReducer(discountSettingsInitialState, {
  [SET_UPDATE_DISCOUNT_SETTINGS]: (state, { payload }) => ({
    ...state,
    discountSettingsIsLoading: payload,
  }),
  [SET_UPDATE_DISCOUNT_BOTTOM_PRICE]: (state, { payload }) => ({
    ...state,
    bottomPriceIsLoading: payload,
  }),
  [SET_FETCH_DISCOUNT_SETTINGS]: (state, { payload }) => ({
    ...state,
    discountSettings: payload,
  }),
});

export default combineReducers({
  blacklist,
  discountSettings,
});
